import React, { useState, createContext, useContext } from 'react';
import { getConsumerFees } from 'capi';
import PropTypes from 'prop-types';
import emptyFunc from '../utils/emptyFunc';

export const ConsumerFeesContext = createContext({});




export const ConsumerFeesProvider = ({ capi, children }) => {
    
    const [consumerFees, setConsumerFees] = useState([]);

    
    const requestConsumerFees = async (currencyCode = '') => {
        const response = await getConsumerFees(capi, currencyCode);
        setConsumerFees(response);
    };

    return (
        <ConsumerFeesContext.Provider
            value={{
                consumerFees,
                requestConsumerFees
            }}
        >
            {children}
        </ConsumerFeesContext.Provider>
    );
};

ConsumerFeesProvider.displayName = 'ConsumerFeesProvider';

ConsumerFeesProvider.propTypes = {
    capi: PropTypes.func,
    children: PropTypes.node.isRequired
};

ConsumerFeesProvider.defaultProps = {
    capi: emptyFunc()
};

export const useConsumerFees = () => useContext(ConsumerFeesContext);
